// ⚠️ 本文件由 scripts/prepare-project.ts 按 project-config skins 清单生成，请勿手工修改。
// 入包皮肤：无（仅基础样式）
import type { SkinDefinition } from '../index';

/** 当前构建入包皮肤（仅这些皮肤的代码进包；指派经 project-config skin 字段） */
export const skinRegistry: Record<string, SkinDefinition> = {
};
